<template>
  <div class="jump-page">
    <el-dialog
      title="请选择登录部门"
      :visible.sync="deptDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="420px"
      top="0"
      custom-class="jump-dept-dialog"
      append-to-body
    >
      <el-select
        v-model="selectedDeptId"
        placeholder="请选择部门"
        filterable
        style="width: 100%"
      >
        <el-option
          v-for="item in sysDeptList"
          :key="item.id"
          :label="item.deptName"
          :value="item.id"
        />
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" :loading="confirmLoading" :disabled="!selectedDeptId" @click="confirmDept">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {userCurrentInfo, switchDept} from '@/api/sys/user'

export default {
  name: 'Jump',
  data() {
    return {
      deptDialogVisible: false,
      selectedDeptId: '',
      sysDeptList: [],
      confirmLoading: false
    }
  },
  created() {
    localStorage.setItem('isLogout', false)
    this.initJump()
  },
  methods: {
    async initJump() {
      const userId = this.$store.state.user.userData.userId
      const routes = JSON.parse(JSON.stringify(this.$store.state.route.addRoutes || []))

      // 超级管理员：不选部门，直接进入系统管理
      if (userId == -1) {
        const route = routes.find(item => item.path === '/sys')
        localStorage.setItem('routeItem', JSON.stringify(route))
        this.$router.push({path: '/sys/user'})
        return
      }

      // 普通用户：获取部门列表并选择
      let info = this.$store.state.user.currentInfoUserData
      if (!info || !Array.isArray(info.sysDeptList)) {
        try {
          const res = await userCurrentInfo()
          info = (res && res.data) || {}
          this.$store.commit('SET_CURRENT_INFO_USERDATA', info)
        } catch (e) {
          this.$message.error('获取用户部门信息失败')
          return
        }
      }

      this.sysDeptList = info.sysDeptList || []

      if (this.sysDeptList.length === 0) {
        this.$message.warning('当前账号未绑定部门')
      }

      // 无论几个部门都弹出选择框，由用户确认后再进入
      this.deptDialogVisible = true
    },

    async confirmDept() {
      if (!this.selectedDeptId) {
        this.$message.warning('请选择部门')
        return
      }
      this.confirmLoading = true
      try {
        const res = await switchDept({deptId: this.selectedDeptId})
        if (!res || res.code !== 200) return

        // 切换部门成功后重新获取用户信息
        await this.$store.dispatch('GetInfo')
        this.$store.commit('SET_CURRENT_DEPT_ID', this.selectedDeptId)

        this.deptDialogVisible = false
        this.$router.push({path: '/home/index'})
      } catch (e) {
        // 错误提示由 axios 拦截器处理
      } finally {
        this.confirmLoading = false
      }
    },
    /** 取消选部门，退出登录并返回登录页 */
    handleCancel() {
      this.deptDialogVisible = false
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({path: '/login'})
      }).catch(() => {
        this.$router.push({path: '/login'})
      })
    }
  }
}
</script>

<style scoped lang="scss">
.jump-page {
  min-height: 100vh;
  background: url('~@/assets/images/login/jump.png') no-repeat center center;
  background-size: cover;
}
</style>

<!-- append-to-body 弹窗需非 scoped 样式才能生效 -->
<style lang="scss">
.jump-dept-dialog {
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
